import React from "react"
import { Card, Flex, Box, Text, Skeleton } from "@radix-ui/themes"
import { LucideIcon } from "lucide-react"

interface StatCardProps {
  title: string
  value: string | number
  icon: LucideIcon
  color: string
  change?: string
  changeType?: "positive" | "negative" | "neutral"
  subtitle?: string
  loading?: boolean
}

const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  icon: Icon,
  color,
  change,
  changeType = "neutral",
  subtitle,
  loading = false
}) => {
  const getChangeColor = () => {
    switch (changeType) {
      case "positive":
        return "green"
      case "negative":
        return "red"
      default:
        return "gray"
    }
  }

  if (loading) {
    return (
      <Card>
        <Flex gap="3" align="center" p="5">
          <Skeleton>
            <Box width="48px" height="48px" />
          </Skeleton>
          <Box flexGrow="1">
            <Skeleton mb="2">
              <Text size="2">Loading title</Text>
            </Skeleton>
            <Skeleton>
              <Text size="6">0000</Text>
            </Skeleton>
          </Box>
        </Flex>
      </Card>
    )
  }

  return (
    <Card className="hover:shadow-md transition-shadow" asChild>
      <div>
        <Flex gap="3" align="center" p="5">
          <Box 
            className={color}
            style={{ 
              padding: '12px',
              borderRadius: 'var(--radius-3)'
            }}
          >
            <Icon className="h-6 w-6 text-white" />
          </Box>
          <Box flexGrow="1">
            <Text size="2" color="gray" mb="1" as="div">
              {title}
            </Text>
            <Flex align="baseline" gap="2">
              <Text size="6" weight="bold">
                {value}
              </Text>
              {change && (
                <Text size="2" weight="medium" color={getChangeColor() as any}>
                  {change}
                </Text>
              )}
            </Flex>
            {subtitle && (
              <Text size="1" color="gray" mt="1" as="div">
                {subtitle}
              </Text>
            )}
          </Box>
        </Flex>
      </div>
    </Card>
  )
}

export default StatCard 